import React, { Component } from 'react';

class Footer extends Component {
	render() {
		return (
			<footer className="mt-0">
				<div className="footer-section">
					<div className="row m-0">
						<div className="col-6 col-md-3 mt-2">
							<p className="section-title">MEOAN ORGANICS</p>
							<ul>
								<li>
									<p className="m-0">Home</p>
								</li>
								<li>
									<p className="m-0">About Us</p>
								</li>
								<li>
									<p className="m-0">Products</p>
								</li>
								<li>
									<p className="m-0">Locate Us</p>
								</li>
								<li>
									<p className="m-0">Contact Us</p>
								</li>
							</ul>
						</div>
						<div className="col-6 col-md-3 mt-2">
							<p className="section-title">MORE INFO</p>
							<ul>
								<li>
									<p className="m-0">Search Product</p>
								</li>
								<li>
									<p className="m-0">Refund Policy</p>
								</li>
								<li>
									<p className="m-0">Privacy Policy</p>
								</li>
								<li>
									<p className="m-0">Terms</p>
								</li>
							</ul>
						</div>
						<div className="col-12 col-md-3 mt-3 mt-md-2">
							<p className="section-title">FOLLOW US</p>
							<ul className="social-icons">
								<li>
									<i className="fa fa-facebook" />
								</li>
								<li>
									<i className="fa fa-instagram" />
								</li>
							</ul>
						</div>
						<div className="col-md-3 d-none d-md-block mt-2">
							<img
								src={require('assets/imgs/footer.png')}
								alt=""
								className="w-100 h-100"
								style={{ objectFit: 'cover' }}
							/>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}
export default Footer;
